export default "<ng-container\r\n  *ngTemplateOutlet=\"template; context: templateContext\"\r\n></ng-container>\r\n";